import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import Select from "react-select";
import DateRangePicker from "react-bootstrap-daterangepicker";
import {
  countryoptions1,
  languageOptions,
  optiondeals,
  optionindustry,
  //options,
  //options,
  //options,
  optionschoose,
  optionsource,
  optionssymbol,
} from "../../../core/common/selectoption/selectoption";
import { Modal } from "react-bootstrap";
import { TableData } from "../../../core/data/interface";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import CollapseHeader from "../../../core/common/collapse-header";
import { all_routes } from "../../router/all_routes";
import { TagsInput } from "react-tag-input-component";
import Offcanvas from 'react-bootstrap/Offcanvas';
import{editLeads, fetchLeads, fetchUsers} from '../../../api/api' // for saveleads
import{getLeads, deleteLeads} from '../../../api/api'
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { fetchLeadsByDate } from "../../../api/api";
import { usePrivileges } from "../../../core/context/PrivilegeContext";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "";


const Leads = () => {
  const { t } = useTranslation();
 // const { privileges } = usePrivileges();
  const route = all_routes;
  const [adduser, setAdduser] = useState(false);
  const [addcompany, setAddCompany] = useState(false);
  const [modalTitle, setModalTitle] = useState("Add New Lead");
  //const data = leadsData;
  //const [owner, setOwner] = useState(["Collab"]);
  const [openModal, setOpenModal] = useState(false);
  const [openModal2, setOpenModal2] = useState(false);
  const [openModal3, setOpenModal3] = useState(false);
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [show3, setShow3] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleClose2 = () => setShow(false);
  const handleShow2 = () => setShow(true);
  // close x on update form
  const handleClose3 = () => {
  setShow3(false);          // just close the Offcanvas
  setSelectedCompany(null); // clear dropdown selection if you want
  setIsEditMode(false);     // exit edit mode
};
  //const handleClose3 = () => setShow(false);
  const handleShow3 = () => setShow(true);

 // Lead form state
const [leadName, setLeadName] = useState("");
const [leadType, setLeadType] = useState<"person" | "organization">("person");

//const [selectedCompany, setSelectedCompany] = useState(null);
const [companyOptions, setCompanyOptions] = useState<any[]>([]);

const [value, setValue] = useState("");
const [selectedCurrency, setSelectedCurrency] = useState(null);
const [currencyOptions, setCurrencyOptions] = useState<any[]>([]);

const [phones, setPhones] = useState<{ number: string; type: any | null }[]>([]);
const [phoneTypeOptions, setPhoneTypeOptions] = useState<any[]>([]);

const [selectedSource, setSelectedSource] = useState(null);
const [sourceOptions, setSourceOptions] = useState<any[]>([]);

const [selectedIndustry, setSelectedIndustry] = useState(null);
const [industryOptions, setIndustryOptions] = useState<any[]>([]);

//const [owner, setOwner] = useState<string[]>([]);
const [tags, setTags] = useState<string[]>([]);
const [description, setDescription] = useState("");

const [visibility, setVisibility] = useState<"public" | "private" | "people">("public");

// Avoid 'status' global conflict
const [leadStatus, setLeadStatus] = useState<"active" | "inactive">("active");

const [leadsList, setLeadsList] = useState<any[]>([]);
//delete lead
 const [selectedLeadId, setSelectedLeadId] = useState(null);

 //Recorder states
   const [recording, setRecording] = useState(false);
   const [audioUrl, setAudioUrl] = useState<string | null>(null);
   const [voiceBlob, setVoiceBlob] = useState<Blob | null>(null);
   const mediaRecorderRef = useRef<MediaRecorder | null>(null);
   const chunks = useRef<Blob[]>([]);

   //admin privileges 
   const token = localStorage.getItem("token");

let isAdmin = false;

if (token) {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    isAdmin = payload?.isAdmin === true;
  } catch (err) {
    console.error("Invalid token", err);
  }
}

const { privileges } = usePrivileges();
 
   //fetch users for lead owner
   const [users, setUsers] = useState<any[]>([]);
const [leadOwner, setLeadOwner] = useState("");
useEffect(() => {
  loadUsers();
}, []);

const loadUsers = async () => {
  try {
    const data = await fetchUsers();
    setUsers(data);    // Stores Name + mid
  } catch (err) {
    console.error("Error loading users", err);
  }
};


  const togglePopup = (isEditing: any) => {
    setModalTitle(isEditing ? "Edit Lead" : "Add New Lead");
    setAdduser(!adduser);
  };
  const addcompanyPopup = () => {
    setAddCompany(!addcompany);
  };

  const [stars, setStars] = useState<{ [key: number]: boolean }>({});

  const handleStarToggle = (index: number) => {
    setStars((prevStars) => ({
      ...prevStars,
      [index]: !prevStars[index],
    }));
  };
  const columns = [
    {
      title: "",
      dataIndex: "",
      render: (text: string, record: any, index: number) => (
        <div
          className={`set-star rating-select ${stars[index] ? "filled" : ""}`}
          onClick={() => handleStarToggle(index)}
        >
          <i className="fa fa-star"></i>
        </div>
      ),
    },
    {
      title: t("leadName"),
      dataIndex: "leads_name",
      key: "lead_name",
      render: (text: any) => (
        <Link to={route.leadsDetails} className="title-name">
          {text}
        </Link>
      ),
      sorter: (a: TableData, b: TableData) =>
        a.lead_name.length - b.lead_name.length,
    },
    // updated company
    {
      title: t("companyName"),
      dataIndex: "compy_name",
      render: (text: any, record: any) => (
        <h2 className="d-flex align-items-center">
          <Link to={`${route.companyDetails}/${record.leads_id}`} className="d-flex flex-column">
            {record.compy_name}
            <span className="text-default">{text.company_address} </span>
          </Link>
        </h2>
      ),
    },
    {
      title: t("phone"),
      dataIndex: "phn1",
      key: "phone",
      sorter: (a: TableData, b: TableData) =>
        a.company_name.length - b.company_name.length,
    },
    {
      title: t("email"), 
      dataIndex: "email",
      key: "email",
      sorter: (a: TableData, b: TableData) =>
        a.company_name.length - b.company_name.length,
    },
    {
      title: t("leadStatus"),
      dataIndex: "leads_status",
      key:"status",
      
      render: (text: string) => (
        <div>
          {text === "New/Fresh" && (
            <span className="badge badge-pill badge-status" style={{backgroundColor:"#3498db",color:"#fff" }}>
              {text}
            </span>
          )}
          {text === "Contacted/Attempted" && (
            <span className="badge badge-pill badge-status" style={{backgroundColor:"#1abc9c",color:"#fff" }} >
              {text}
            </span>
          )}
          {text === "In progress/Working" && (
            <span className="badge badge-pill badge-status" style={{backgroundColor:"#e67e22",color:"#fff"}}>
              {text}
            </span>
          )}
          {text === "Qualified" && (
            <span className="badge badge-pill badge-status" style={{backgroundColor:"#9b59b6",color:"#fff"}}>
              {text}
            </span>
          )}
          {text === "Unqualified/Disqualified" && (
            <span className="badge badge-pill badge-status" style={{backgroundColor:"#95a5a6",color:"#fff"}}>
              {text}
            </span>
          )}
          {text === "Interested/Warm" && (
            <span className="badge badge-pill badge-status" style={{backgroundColor:"#f1c40f",color:"#fff"}}>
              {text}
            </span>
          )}
          {text === "Negotiation/Proposal Sent" && (
            <span className="badge badge-pill badge-status" style={{backgroundColor:"#3f51b5",color:"#fff"}}>
              {text}
            </span>
          )}
          {text === "Won/Converted" && (
            <span className="badge badge-pill badge-status" style={{backgroundColor:"#27ae60",color:"#fff"}}>
              {text}
            </span>
          )}
          {text === "Lost" && (
            <span className="badge badge-pill badge-status" style={{backgroundColor:"#e74c3c",color:"#fff"}}>
              {text}
            </span>
          )}
          {text === "Follow-Up/On Hold" && (
            <span className="badge badge-pill badge-status" style={{backgroundColor:"#ff9800",color:"#fff"}}>
              {text}
            </span>
          )}
      </div>
      ),
      sorter: true,
    },
    {
      title: t("createdDate"),
      dataIndex: "created_date",
      key: "created_date",
      sorter: (a: TableData, b: TableData) => {
        // Convert to timestamps for comparison
        // const dateA = a.created_date ? new Date(a.created_date).getTime() : 0;
        // const dateB = b.created_date ? new Date(b.created_date).getTime() : 0;
        // return dateA - dateB;
      },
    },
    {
      title: t("leadOwner"), 
      dataIndex: "leads_owner",
      key: "owner",
      sorter: (a: TableData, b: TableData) =>
        (a.owner || "").localeCompare(b.owner || ""),
    },
    {
      title:  t("voice"),
      dataIndex: "voice_note", 
      key: "voice_note",
      render: (voice_note: string) =>
        voice_note ? (
          <audio
            controls
           src={`${API_BASE_URL}${voice_note}`}// full URL to access the file
            style={{ width: "180px" }}
          />
        ) : (
          <span>No Voice</span>
        ),
    },

    {
      title:  t("action"),
      dataIndex: "action",
      render: (_: any, record: any) => (
        <div className="dropdown table-action">
          <Link
            to="#"
            className="action-icon "
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa fa-ellipsis-v" />
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            {(isAdmin || privileges.includes("update_leads")) && (
  <Link
    className="dropdown-item"
    to="#"
    onClick={() => handleEdit(record)}
  >
    <i className="ti ti-edit text-blue" /> {t("edit")}
  </Link>
)}

           {(isAdmin || privileges.includes("delete_leads")) && (
  <Link
    className="dropdown-item"
    to="#"
    data-bs-toggle="modal"
    data-bs-target="#delete_lead"
    onClick={() => setSelectedLeadId(record.leads_id)}
  >
    <i className="ti ti-trash text-danger"></i> {t("delete")}
  </Link>
)}

            {/* <Link className="dropdown-item" to="#">
              <i className="ti ti-clipboard-copy text-blue-light" />{t("clone")}
            </Link> */}
          </div>
        </div>
      ),
    },
  ];
  //interface
  interface Lead {
  leads_id?: string;
  compy_name: string;
  phn1: string;
  phn2: string;
  email: string;
  website: string;
  source: string;
  industry: string;
  currency: string;
  language: string;
  description: string;
  leads_status: string;
  leads_name: string;
  leads_owner: string;
  created_date: string;
  voice_note?: string; 
}
// to fetch dats by filtering



  const today = new Date();
const yesterday = new Date();
yesterday.setDate(today.getDate() - 1);

const last7Start = new Date();
last7Start.setDate(today.getDate() - 6);

const last30Start = new Date();
last30Start.setDate(today.getDate() - 29);

const thisMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
const thisMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0);

const lastMonthStart = new Date(today.getFullYear(), today.getMonth() - 1, 1);
const lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0);

const initialSettings = {
  startDate: last7Start,
  endDate: today,

  ranges: {
    "Last 7 Days": [last7Start, today],
    "Last 30 Days": [last30Start, today],
    "This Month": [thisMonthStart, thisMonthEnd],
    "Last Month": [lastMonthStart, lastMonthEnd],
    "Today": [today, today],
    "Yesterday": [yesterday, yesterday],
  },

  timePicker: false,
};
const [dateRange, setDateRange] = useState({
  startDate: last7Start,
  endDate: today
});

const handleDateApply = async (
  event: any,
  picker: { startDate: any; endDate: any }
) => {
  const start = picker.startDate.toDate();
  const end = picker.endDate.toDate();

  setDateRange({ startDate: start, endDate: end });

  try {
    const data = await fetchLeadsByDate(
      start.toISOString().split("T")[0],
      end.toISOString().split("T")[0]
    );
    setLeadsList(data);
  } catch (err) {
    console.error("Date filter failed", err);
  }
};


  const [newContents, setNewContents] = useState<number[]>([0]);

  const addNewContent = () => {
    setNewContents([...newContents, newContents.length]);
  };

  const currency = [
     {value: "Choose", label: "Choose"},
     { value: "USD", label: "USD" },
     { value: "INR", label: "INR" },
     { value: "SAR", label: "SAR" },
     { value: "AED", label: "AED" },
     { value: "EUR", label: "EUR" },
     { value: "GBP", label: "GBP" },
     { value: "CNY", label: "CNY" },
  ];
    //save leads
    const [leads, setLeads] = useState({

        //id: "",  
        leads_id: "",
        compy_name: "",
        phn1: "",
        phn2: "",
        email: "",
        website: "",
        source: "",
        industry: "",
        currency: "",
        language: "",
        description: "",
        leads_status: "",
        leads_name:"",
         leads_owner: "",  // ADD THIS FIELD
     created_date: dayjs().format("YYYY-MM-DD HH:mm:ss"),
     voice_note: "",

    });
    // initial empty state refreshing form
    const initialLeadsState = {
      compy_name: "",
      email: "",
      leads_name: "",
      leads_owner: "",
      phn1: "",
      phn2: "",
      website: "",
      source: "",
      industry: "",
      currency: "",
      language: "",
      leads_status: "",
      created_date:dayjs().format("DD-MM-YYYY HH:mm:ss"),//  default today
      description: "",
      voice_note: "",
    };
    
    // UI states for filtering/search
    interface Filters {
      leadNames: string[];
      companies: string[];
      statuses: string[];
      owners: string[];
      dates: string[]; // using string for UI display dates
    }

    const [filters, setFilters] = useState<Filters>({
      leadNames: [],
      companies: [],
      statuses: [],
      owners: [],
      dates: [],
    });

    const [searchTerm, setSearchTerm] = useState("");

    // toggle filter
    const toggleFilter = <K extends keyof Filters>(key: K, value: string) => {
      setFilters(prev => {
        const arr = prev[key];
        return {
          ...prev,
          [key]: arr.includes(value) ? arr.filter(v => v !== value) : [...arr, value],
        };
      });
    };

    // derive filtered list
    const filteredLeads = React.useMemo(() => {
  let list = leadsList ?? [];
  const q = searchTerm.trim().toLowerCase();

  if (q) {
    list = list.filter(l => {
      const leadName = (l.leads_name || "").toString().toLowerCase();
      const company = (l.compy_name || "").toString().toLowerCase();
      const email = (l.email || "").toString().toLowerCase();

      return (
        leadName.startsWith(q) ||
        company.startsWith(q) ||
        email.startsWith(q)
      );
    });
  }

  if (filters.leadNames.length) {
    list = list.filter(l => filters.leadNames.includes(l.leads_name));
  }

  if (filters.companies.length) {
    list = list.filter(l => filters.companies.includes(l.compy_name));
  }

  if (filters.statuses.length) {
    list = list.filter(l => filters.statuses.includes(l.leads_status));
  }

  if (filters.owners.length) {
    list = list.filter(l => filters.owners.includes(l.leads_owner));
  }

  return list;
}, [leadsList, searchTerm, filters]);


    //handle from input
    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
        setLeads({ ...leads, [e.target.name]: e.target.value });
      };

    //for handle submit
    const handleSubmit = async (e?: React.FormEvent) => {
      if (e) e.preventDefault();
      try {
        const payload = {
      ...leads,
      created_date: dayjs().format("YYYY-MM-DD HH:mm:ss"),
    };

        //console.log("Submitting leads payload:", leads);
        console.log("Submitting leads payload:", payload);

        const result = await fetchLeads(payload);

        alert(result.message); // "Data inserted successfully"

        // reset form
        setLeads({
          //id: "",  
          leads_id: "",
          compy_name: "",
          phn1: "",
          phn2: "",
          email: "",
          website: "",
          source: "",
          industry: "",
          currency: "",
          language: "",
          description: "",
          leads_status: "",
          leads_name:"",
          leads_owner: "",
        created_date: dayjs().format("YYYY-MM-DD HH:mm:ss"), //default today
        voice_note: "",
        });

        // Refresh leads list
        fetchLeadsList();
        return result; // return the API response
      } catch {
        alert("Failed to save lead");
        throw new Error("Save failed"); 
      }
    };
    
    //handle ceate click for save leads
    const handleCreateClick = async () => {

    if (!isAdmin && !privileges.includes("save_leads")) {
  alert("No permission to save leads");
  return;
}

      // Required fields
      const requiredFields = [
        "compy_name",
        "email",
        "leads_name",
        "leads_owner",
        "phn1",
        "website",
        "source",
        "industry",
        "currency",
        "language",
        "leads_status",
        //"created_date",
        "description"
      ];
       console.log("zzzzzz",leads);
      // Find missing ones
      const missing = requiredFields.filter((f) => !leads[f as keyof typeof leads]);

      if (missing.length > 0) {
        alert("Please fill all required fields before saving.");
        return; // stop execution
      }

      try {
        const result = await handleSubmit();
        if (result?.message === "Data inserted successfully") {
          setShow(false);     // close Offcanvas
          setOpenModal(true); // open details modal
        }
      } catch (err) {
        console.error("Error creating lead:", err);
      }
    };
    //disable the button
    const isFormValid = () => {
      return (
        !!leads.compy_name &&
        !!leads.email &&
        !!leads.leads_name &&
        !!leads.leads_owner &&
        !!leads.phn1 &&
        !!leads.website &&
        !!leads.source &&      
        !!leads.industry &&    
        !!leads.currency &&
        !!leads.language &&    
        //!!leads.created_date &&
        !!leads.description   //!! — ensures null, undefined, and empty strings are all treated as invalid.
      );
    };

    // fetch leads for display
    const fetchLeadsList = async () => {
      try {
        const data = await getLeads();
        console.log("Leads API response:", data);
        
        setLeadsList(data);

        setCompanyOptions( //for dropdown of selection
          data.map((lead: any) => ({
            value: lead.leads_id,
            label: lead.compy_name || "",
            
            
          }))
        );
      } catch (error) {
        console.error("Error fetching leads:", error);
      }
    };

    // useEffect to fetch leads on component mount
    useEffect(() => {
      fetchLeadsList();
    }, []);
    useEffect(() => {
      console.log("Company options updated:", companyOptions);
    }, [companyOptions]);

    //for add new phn mock updation
    const addNewPhone = () => {
      setPhones([...phones, { number: "", type: null }]);
    };
      function updatePhoneType(index: number, option: any): void {
        throw new Error("Function not implemented.");
      }

    //edit leads section
    // Function when clicking edit
    const [isEditMode, setIsEditMode] = useState(false);

    // After: define type for react-select option
    interface SelectOption {
      value: string;
      label: string;
    }

    const [selectedCompany, setSelectedCompany] = useState<SelectOption | null>(null);
    //button inside  the action

    // voice recording on edit
    const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      mediaRecorderRef.current = new MediaRecorder(stream);

      mediaRecorderRef.current.ondataavailable = (e) => {
        chunks.current.push(e.data);
      };

      mediaRecorderRef.current.onstop = () => {
        const blob = new Blob(chunks.current, { type: "audio/webm" });
        chunks.current = [];
        const url = URL.createObjectURL(blob);
        setAudioUrl(url);
        setVoiceBlob(blob);
      };

      mediaRecorderRef.current.start();
      setRecording(true);
    } catch (error) {
      console.error("Mic access error:", error);
    }
  };

  //Stop Recording
  const stopRecording = () => {
    mediaRecorderRef.current?.stop();
    setRecording(false);
  };



    const handleEdit = (record: any) => {

    if (!isAdmin && !privileges.includes("update_leads")) {
  alert("No permission to edit leads");
  return;
}
      setLeads({
        //id: record.id || "",
        leads_id: record.leads_id || "",
        compy_name: record.compy_name || "",
        phn1: record.phn1 || "",
        phn2: record.phn2 || "",
        email: record.email || "",
        website: record.website || "",
        source: record.source || "",
        industry: record.industry || "",
        currency: record.currency || "",
        language: record.language || "",
        description: record.description || "",
        leads_status: record.leads_status || "",
        leads_name: record.leads_name || "",
        leads_owner: record.leads_owner || "",

        created_date: record.created_date || "",
        voice_note: record.voice_note || "",
      });
      

      setSelectedCompany({ 
        value: record.leads_id, 
        label: record.compy_name 
      });

      setIsEditMode(true); // switch to edit mode
      setShow3(true);      // open the Offcanvas
      
    };
    //refreshing on edit close (refresh if not updated)
    useEffect(() => {
  // When Offcanvas closes (show3 goes false)
      if (!show3 && !isEditMode) {
        handleCreate(); // reset form only if not editing
      }
    }, [show3, isEditMode]);
   
    // Function when clicking "Add New Lead"
      
    const handleCreate = () => {
          setLeads({
          //id: "",  
          leads_id: "",
          compy_name: "",
          phn1: "",
          phn2: "",
          email: "",
          website: "",
          source: "",
          industry: "",
          currency: "",
          language: "",
          description: "",
          leads_status: "",
          leads_name: "",
          leads_owner: "",
          created_date: "",
          voice_note: "",
        });
          // reset form
          setSelectedCompany(null);   //clear selected company
          setIsEditMode(false);    // switch to create mode
          //setShowModal(true);      // open modal
        };
    //save edit button inside the form
    const handleSave = async () => {

    if (
  isEditMode &&
  !isAdmin &&
  !privileges.includes("update_leads")
) {
  alert("No permission to update leads");
  return;
}

if (
  !isEditMode &&
  !isAdmin &&
  !privileges.includes("save_leads")
) {
  alert("No permission to save leads");
  return;
}

      try {
        // Check if company is selected (react-select)
        if (!selectedCompany) {
          alert("Please select a company");
          return;
        }
        // Prepare payload
        const payload = {
          ...leads,
           leads_id: selectedCompany?.value || leads.leads_id,
          compy_name: selectedCompany?.label || leads.compy_name,
          phn1: leads.phn1 || "",
          phn2: leads.phn2 || "",
          email: leads.email || "",
          website: leads.website || "",
          source: leads.source || "",
          industry: leads.industry || "",
          currency: leads.currency || "",
          language: leads.language || "",
          description: leads.description || "",
          leads_status: leads.leads_status || "",
          leads_name: leads.leads_name || "",
          leads_owner: leads.leads_owner || "",
          //created_date: leads.created_date || "",
          voice_note: leads.voice_note || "",
        };

         // build FormData if voiceBlob exists
    const formData = new FormData();
    Object.entries(payload).forEach(([key, value]) => {
      formData.append(key, value as any);
    });
    if (voiceBlob) {
      formData.append("voice", voiceBlob, "voiceNote.webm");
    }

        console.log("Leads API payload:", payload);

        if (isEditMode) {
          // Update existing lead
          await editLeads(selectedCompany.value, payload, voiceBlob);
          alert("Lead updated successfully!");
          setShow3(false); // close edit Offcanvas
        } else {
          // Create new lead
          createLeads(payload, voiceBlob);
          alert("Lead created successfully!");
          setShowModal(false); // close create modal
        }

        // Refresh leads list
        console.log("Leads API responseeeeee:", payload);
        //refresh table immediately
        // Refresh leads list
        await fetchLeadsList()
        .then(() => {
          handleCreate();
          setVoiceBlob(null); // reset voice after save
        })
        .catch((error) => {
          console.error("Error refreshing leads list:", error);
        });
      } catch (error) {
        console.error("Error saving lead:", error);
        alert("Failed to save lead");
      }
    };
    
    // validation
    const isEditFormValid = () => {
      return (
        !!leads.compy_name &&
        !!leads.email &&
        !!leads.leads_name &&
        !!leads.leads_owner &&
        !!leads.phn1 &&
        !!leads.website &&
        !!leads.source &&
        !!leads.industry &&
        !!leads.currency &&
        !!leads.language &&
        !!leads.created_date &&
        !!leads.description &&
        !!selectedCompany
      );
    };
    
    
    //delete lead
    const handleDeleteLead = async () => {

      if (!isAdmin && !privileges.includes("delete_leads")) {
  alert("No permission to delete leads");
  return;
}

      if (!selectedLeadId) return;

      try {
        await deleteLeads(selectedLeadId);
        // Refresh leads list
        const updatedLeads = await getLeads();
        setLeadsList(updatedLeads);

        console.log("Lead deleted successfully");
      } catch (error) {
        console.error("Error deleting lead:", error);
      }
    };

    
  //   function updatePhone(index: number, value: string): void {
  //   throw new Error("Function not implemented.");
  // }
  
  return (
    <>
      <>
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content">
            <div className="row">
              <div className="col-md-12">
                {/* Page Header */}
                <div className="page-header">
                  <div className="row align-items-center">
                    <div className="col-4">

                       {/* //changing for remove mockdatas */}

                     <h4 className="page-title">
                      {t("leads")}<span className="count-title">{filteredLeads.length}</span>
                    </h4>

                    </div>
                    <div className="col-8 text-end">
                      <div className="head-icons">
                        <CollapseHeader />
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Page Header */}
                <div className="card">
                  <div className="card-header">
                    {/* Search */}
                    <div className="row align-items-center">
                      <div className="col-sm-4">
                        <div className="icon-form mb-3 mb-sm-0">
                          <span className="form-icon">
                            <i className="ti ti-search" />
                          </span>
                            <input
                              type="text"
                              className="form-control"
                              placeholder={t("Search Leads")}
                              value={searchTerm}
                              onChange={e => setSearchTerm(e.target.value)}
                            />

                        </div>
                      </div>
                      <div className="col-sm-8">
                        <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end">
                          {/* <div className="dropdown me-2">
                            <Link
                              to="#"
                              className="dropdown-toggle"
                              data-bs-toggle="dropdown"
                            >
                              <i className="ti ti-package-export me-2" />
                             {t("export")}
                            </Link>
                            <div className="dropdown-menu  dropdown-menu-end">
                              <ul>
                                <li>
                                  <Link to="#" className="dropdown-item">
                                    <i className="ti ti-file-type-pdf text-danger me-1" />
                                    {t("exportAsPDF")}
                                  </Link>
                                </li>
                                <li>
                                  <Link to="#" className="dropdown-item">
                                    <i className="ti ti-file-type-xls text-green me-1" />
                                   {t("exportAsExcel")}{" "}
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div> */}
                          <Link
                            to="#"
                            className="btn btn-primary"
                            onClick={handleShow2}
                          >
                            <i className="ti ti-square-rounded-plus me-2" />
                             {t("addLeads")}
                          </Link>
                        </div>
                      </div>
                    </div>
                    {/* /Search */}
                  </div>
                  <div className="card-body">
                    {/* Filter */}
                    <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-4">
                      <div className="d-flex align-items-center flex-wrap row-gap-2">
                        {/* <div className="dropdown me-2">
                          <Link
                            to="#"
                            className="dropdown-toggle"
                            data-bs-toggle="dropdown"
                          >
                            <i className="ti ti-sort-ascending-2 me-2" />
                          {t("sort")}
                          </Link>
                          <div className="dropdown-menu  dropdown-menu-start">
                            <ul>
                              <li>
                                <Link to="#" className="dropdown-item">
                                  <i className="ti ti-circle-chevron-right me-1" />
                                  {t("ascending")}
                                </Link>
                              </li>
                              <li>
                                <Link to="#" className="dropdown-item">
                                  <i className="ti ti-circle-chevron-right me-1" />
                                  {t("descending")}
                                </Link>
                              </li>
                              <li>
                                <Link to="#" className="dropdown-item">
                                  <i className="ti ti-circle-chevron-right me-1" />
                                  {t("recentlyViewed")}
                                </Link>
                              </li>
                              <li>
                                <Link to="#" className="dropdown-item">
                                  <i className="ti ti-circle-chevron-right me-1" />
                                  {t("recentlyAdded")}
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div> */}
                        <div className="icon-form">
                          <span className="form-icon">
                            <i className="ti ti-calendar" />
                          </span>
                          <DateRangePicker initialSettings={initialSettings}
                          onApply={handleDateApply}
                          >
                            <input
                              className="form-control bookingrange"
                              type="text"
                            />
                          </DateRangePicker>
                        </div>
                      </div>
                      <div className="d-flex align-items-center flex-wrap row-gap-2">
                        <div className="dropdown me-2">
                          <Link
                            to="#"
                            className="btn bg-soft-purple text-purple"
                            data-bs-toggle="dropdown"
                            data-bs-auto-close="outside"
                          >
                            <i className="ti ti-columns-3 me-2" />
                             {t("manageColumns")}
                          </Link>
                          <div className="dropdown-menu  dropdown-menu-md-end dropdown-md p-3">
                            <h4 className="mb-2 fw-semibold">
                             {t("wantToManageDatatables")}

                            </h4>
                            <p className="mb-3">
                              {t("dragDropColumnsInstruction")}

                            </p>

                            {/* //created leads displaying */} 
                            {/* 111  table datas displaying*/}
                          </div>
                        </div>
                        
                      <div className="view-icons">
                          <Link to={route.leads} className={true ? "active" : ""}>
                            <i className="ti ti-list-tree" />
                          </Link>
                          <Link to={route.leadsKanban}>
                            <i className="ti ti-grid-dots" />
                          </Link>
                        </div>
                        </div>
                      </div>
                      
                      {/* /Filter */}
                    {/* Contact List */}
                    <div className="table-responsive custom-table">
                    <Table dataSource={filteredLeads} columns={columns} />    
                    </div>
                   
                    <div className="row align-items-center">
                      <div className="col-md-6">
                        <div className="datatable-length" />
                      </div>
                      <div className="col-md-6">
                        <div className="datatable-paginate" />
                      </div>
                    </div>
                    {/* /Contact List */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Page Wrapper */}
      
        {/* Add Leads (Save) */}
        <Offcanvas show={show} onHide={handleClose} placement="end">
          <div className="offcanvas-header border-bottom">
            <h5 className="fw-semibold"> {t("addNewLead")}</h5>
            <button
              type="button"
              className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
              onClick={handleClose}
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
          </div>

          <div className="offcanvas-body">
            <form onSubmit={handleSubmit}>
              <div className="accordion" id="main_accordion">
                {/* Basic Info */}
                <div className="accordion-item rounded mb-3">
                  {/* <div className="accordion-header">
                    <Link
                      to="#"
                      className="accordion-button accordion-custom-button bg-white rounded fw-medium text-dark"
                      data-bs-toggle="collapse"
                      data-bs-target="#basic"
                    >
                      <span className="avatar avatar-md rounded text-dark border me-2">
                        <i className="ti ti-user-plus fs-20" />
                      </span>
                     {t("basicInfo")}
                    </Link>
                  </div> */}
                  <div
                    className="accordion-collapse collapse show"
                    id="basic"
                    data-bs-parent="#main_accordion"
                  >
                    <div className="accordion-body border-top">
                      
                      <div className="row">
                        <div className="col-md-12">

                          <div className="mb-3">
                          <div className="row">
                            {/* Left: Image Upload */}
                            <div className="col-md-6">
                              <div className="profile-upload">
                                {/* <div className="profile-upload-img">
                                  <span>
                                    <i className="ti ti-photo" />
                                  </span>
                                  <ImageWithBasePath
                                    src="assets/img/profiles/avatar-20.jpg"
                                    alt="img"
                                    className="preview1"
                                  />
                                  <button type="button" className="profile-remove">
                                    <i className="ti ti-x" />
                                  </button>
                                </div> */}

                                {/* <div className="profile-upload-content">
                                  <label className="profile-upload-btn">
                                    <i className="ti ti-file-broken" /> {t("uploadFile")}
                                    <input type="file" className="input-img" />
                                  </label>
                                  <p>{t("fileTypesInfo")}</p>
                                  <p>JPG, GIF or PNG. Max size of 800K</p>
                                </div> */}
                              </div>
                            </div>

                            {/* Right: Lead Status Dropdown */}
                            <div className="col-md-6 d-flex align-items-center">
                              <div className="w-100">
                                <label className="col-form-label">
                                  {t("leadStatus")} <span className="text-danger">*</span>
                                </label>
                                <select
                                  className="form-control"
                                  name="leads_status"
                                  value={leads.leads_status || ""}
                                  onChange={handleChange}
                                  
                                >
                                  <option value="">{t("selectStatus")}</option>
                                  <option value="New/Fresh">{t("newFresh")}</option>
                                  <option value="Contacted/Attempted">{t("contactedAttempted")}</option>
                                  <option value="In progress/Working">{t("inProgressWorking")}</option>
                                  <option value="Qualified">{t("qualified")}</option>
                                  <option value="Unqualified/Disqualified">{t("unqualifiedDisqualified")}</option>
                                  <option value="Interested/Warm">{t("interestedWarm")}</option>
                                  <option value="Negotiation/Proposal Sent">{t("negotiationProposalSent")}</option>
                                  <option value="Won/Converted">{t("wonConverted")}</option>
                                  <option value="Lost">{t("lost")}</option>
                                  <option value="Follow-Up/On Hold">{t("followUpOnHold")}</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* leads status dropdown ends here */}
                        </div>

                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="col-form-label">{t("companyName")}</label>
                            <input
                              type="text"
                              className="form-control"
                              value={leads.compy_name}
                              onChange={handleChange}
                              name="compy_name"
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="mb-3">
                            <div className="d-flex justify-content-between align-items-center">
                              <label className="col-form-label">
                                {t("email")} <span className="text-danger">*</span>
                              </label>
                            </div>
                            <input
                              type="text"
                              className="form-control"
                              name="email"
                              value={leads.email}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        {/* Lead Name */}
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              {t("leadName")} <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={leads.leads_name}
                              onChange={handleChange}
                              name="leads_name"
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              {t("phone1")} <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={leads.phn1}
                              onChange={handleChange}
                              name="phn1"
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">{t("phone2")}</label>
                            <input
                              type="text"
                              className="form-control"
                              value={leads.phn2}
                              onChange={handleChange}
                              name="phn2"
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              {t("website")} <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={leads.website}
                              onChange={handleChange}
                              name="website"
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              {t("source")} <span className="text-danger">*</span>
                            </label>
                            <Select
                              className="select2"
                              options={optionsource}
                              classNamePrefix="react-select"
                              value={optionsource.find((opt) => opt.value === leads.source)}
                              onChange={(selectedOption) =>
                                setLeads({ ...leads, source: selectedOption?.value || "" })
                              }
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              {t("industry")} <span className="text-danger">*</span>
                            </label>
                            <Select
                              className="select2"
                              options={optionindustry}
                              classNamePrefix="react-select"
                              value={optionindustry.find((opt) => opt.value === leads.industry)}
                              onChange={(selectedOption) =>
                                setLeads({ ...leads, industry: selectedOption?.value || "" })
                              }
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              {t("currency")} <span className="text-danger">*</span>
                            </label>
                            <Select
                              className="select"
                              options={currency}
                              value={currency.find((opt) => opt.value === leads.currency) || null}
                              onChange={(option) =>
                              setLeads((prev: any) => ({ ...prev, currency: option?.value || "" }))
                              }
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              {t("language")} <span className="text-danger">*</span>
                            </label>
                            <Select
                              className="select"
                              options={languageOptions}
                              value={languageOptions.find((opt) => opt.value === leads.language)}
                              onChange={(selectedOption) =>
                                setLeads({ ...leads, language: selectedOption?.value || "" })
                              }
                            />
                          </div>
                        </div>

                        {/* lead owner */}
                              <div className="col-md-6">
                                <div className="mb-3">
                                  <label className="col-form-label">
                                    {t("leadOwner")} <span className="text-danger">*</span>
                                  </label>
                                <Select
                                className="select"
                                options={users.map((u) => ({
                                  value: u.Name,   // <-- username will be saved
                                  label: u.Name,   // <-- username shown in UI
                                }))}

                                value={users
                                  .map((u) => ({ value: u.Name, label: u.Name }))
                                  .find((opt) => opt.value === leads.leads_owner) || null}

                                onChange={(selectedOption) =>
                                  setLeads({ ...leads, leads_owner: selectedOption?.value || "" })
                                }
                              />

                                </div>
                              </div>

                          {/* lead owner */}

                        <div className="col-md-12">
                          <div className="mb-0">
                            <label className="col-form-label">
                              {t("description")} <span className="text-danger">*</span>
                            </label>
                            <textarea
                              className="form-control"
                              rows={5}
                            value={leads.description || ""}
                              name="description"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Basic Info */}
              </div>

              <div className="d-flex align-items-center justify-content-end gap-2">
              <button 
                type="button" 
                data-bs-dismiss="offcanvas" 
                className="btn btn-light"
              >
                {t("cancel")}
              </button>

              <button 
                type="button" 
                className="btn btn-primary"
                onClick={handleCreateClick}// for save created lead
                disabled={!isFormValid()}   // disable until valid
              >
                {t("create")}
              </button>
            </div>

            </form>
          </div>
       </Offcanvas>
        {/* /Add New Lead */}

        {/* Edit Lead */}
      <Offcanvas show={show3} onHide={handleClose3} placement="end">
        <div className="offcanvas-header border-bottom">
          <h5 className="fw-semibold">{isEditMode ? "Edit Lead" : "Create Lead"}</h5>
          <button
            type="button"
            className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
            onClick={handleClose3}
            aria-label="Close"
          >
            <i className="ti ti-x" />
          </button>
        </div>

      <div className="offcanvas-body">
        <form>
          <div className="row">

        
        
        {/* Lead Name */}
        <div className="col-md-12">
          <div className="mb-3">
            <label className="col-form-label">
              {t("leadName")} <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              value={leads.leads_name || ""}
              onChange={(e) =>
                setLeads((prev: any) => ({ ...prev, leads_name: e.target.value }))
              }
            />
          </div>
        </div>

        {/* Company Name */}
        <div className="col-md-12">
          <div className="mb-3">
            <div className="d-flex justify-content-between align-items-center">
              <label className="col-form-label">{t("companyName")} <span className="text-danger">*</span>
              </label>
              <Link to="" className="label-add" onClick={handleShow}>
                <i className="ti ti-square-rounded-plus" />
               {t("addNew")}
              </Link>
            </div>
            <Select
              className="select"
              options={companyOptions}
              value={selectedCompany}
              onChange={(option) => {
                setSelectedCompany(option);
                setLeads((prev: any) => ({
                  ...prev,
                  leads_id: option?.value || "",
                  compy_name: option?.label || "",
                }));
              }}
              placeholder="Select Company"
            />
          </div>
        </div>
        {/* status */}
        <div className="col-md-6">
          <label className="col-form-label">
          {t("leadStatus")} <span className="text-danger">*</span>
          </label>
          <select
          className="form-control"
          name="leads_status"
          value={leads.leads_status || ""}
          onChange={handleChange}
          
        >
          <option value="">{t("selectStatus")}</option>
          <option value="New/Fresh">{t("newFresh")}</option>
          <option value="Contacted/Attempted">{t("contactedAttempted")}
          </option>
          <option value="In progress/Working">{t("inProgressWorking")}</option>
          <option value="Qualified">{t("qualified")}</option>
          <option value="Unqualified/Disqualified">{t("unqualifiedDisqualified")}</option>
          <option value="Interested/Warm">{t("interestedWarm")}</option>
          <option value="Negotiation/Proposal Sent">{t("negotiationProposalSent")}</option>
          <option value="Won/Converted">{t("wonConverted")}</option>
          <option value="Lost">{t("lost")}</option>
          <option value="Follow-Up/On Hold">{t("followUpOnHold")}</option>
        </select>
      </div>
        {/* Phone */}
        <div className="col-md-6">
          <div className="mb-3">
            <label className="col-form-label">{t("phone1")} <span className="text-danger">*</span>

            </label>
            <input
              type="text"
              className="form-control"
              value={leads.phn1 || ""}
              onChange={(e) =>
                setLeads((prev: any) => ({ ...prev, phn1: e.target.value }))
              }
            />
          </div>
        </div>

        <div className="col-md-6">
          <div className="mb-3">
            <label className="col-form-label">{t("phone2")}</label>
            <input
              type="text"
              className="form-control"
              value={leads.phn2 || ""}
              onChange={(e) =>
                setLeads((prev: any) => ({ ...prev, phn2: e.target.value }))
              }
            />
          </div>
        </div>

        {/* Email */}
        <div className="col-md-6">
          <div className="mb-3">
            <label className="col-form-label">{t("email")} <span className="text-danger">*</span>

            </label>
            <input
              type="email"
              className="form-control"
              value={leads.email || ""}
              onChange={(e) =>
                setLeads((prev: any) => ({ ...prev, email: e.target.value }))
              }
            />
          </div>
        </div>

        {/* Website */}
        <div className="col-md-6">
          <div className="mb-3">
            <label className="col-form-label">{t("website")} <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              value={leads.website || ""}
              onChange={(e) =>
                setLeads((prev: any) => ({ ...prev, website: e.target.value }))
              }
            />
          </div>
        </div>

        {/* Source */}
        <div className="col-md-6">
          <div className="mb-3">
            <label className="col-form-label">{t("source")} <span className="text-danger">*</span>

            </label>
            <Select
              className="select"
              options={optionsource}
              value={
                optionsource.find((opt) => opt.value === leads.source) || null
              }
              onChange={(option) =>
                setLeads((prev: any) => ({ ...prev, source: option?.value || "" }))
              }
            />
          </div>
        </div>

        {/* Industry */}
        <div className="col-md-6">
          <div className="mb-3">
            <label className="col-form-label">{t("industry")} <span className="text-danger">*</span>

            </label>
            <Select
              className="select"
              options={optionindustry}
              value={
                optionindustry.find((opt) => opt.value === leads.industry) || null
              }
              onChange={(option) =>
                setLeads((prev: any) => ({ ...prev, industry: option?.value || "" }))
              }
            />
          </div>
        </div>

        {/* Currency */}
        <div className="col-md-6">
          <div className="mb-3">
            <label className="col-form-label">{t("currency")} <span className="text-danger">*</span>

            </label>
            <Select
              className="select"
              options={currency}
              value={currency.find((opt) => opt.value === leads.currency) || null}
              onChange={(option) =>
                setLeads((prev: any) => ({ ...prev, currency: option?.value || "" }))
              }
            />
          </div>
        </div>
        {/* Lead Owner */}
      <div className="col-md-6">
        <div className="mb-3">
          <label className="col-form-label">
            {t("leadOwner")} <span className="text-danger">*</span>
          </label>
          <Select
            className="select"
            options={users.map((u) => ({
              value: u.Name,   // value saved in lead
              label: u.Name,   // label shown in dropdown
            }))}
            value={users
              .map((u) => ({ value: u.Name, label: u.Name }))
              .find((opt) => opt.value === leads.leads_owner) || null} // pre-select saved owner
            onChange={(selectedOption) =>
              setLeads({ ...leads, leads_owner: selectedOption?.value || "" }) // update state
            }
            placeholder={t("selectLeadOwner")}
          />
        </div>
      </div>

              {/* voice note */}
           <div className="col-md-3 d-flex align-items-end">
              <div>
                <label className="form-label form-label-sm">{t("voiceNote")}</label>
                <div>
                  {recording ? (
                    <button
                      type="button"
                      className="btn btn-danger me-2"
                      onClick={stopRecording}
                      style={{ padding: "8px 15px", fontSize: "0.80rem" }}
                    >
                      {t("stop")}
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="btn btn-success me-2"
                      onClick={startRecording}
                      style={{ padding: "8px 18px", fontSize: "0.80rem" }}
                    >
                      {t("record")}
                    </button>
                  )}
                </div>
              </div>
            </div>
        {/* voice note ends here */}

        {/* Description */}
        <div className="col-md-12">
          <div className="mb-3">
            <label className="col-form-label">{t("description")} <span className="text-danger">*</span>

            </label>
            <textarea
              className="form-control"
              rows={5}
              value={leads.description || ""}
              onChange={(e) =>
                setLeads((prev: any) => ({ ...prev, description: e.target.value }))
              }
            />
          </div>
        </div>
      </div>

      {/* Buttons */}
      <div className="d-flex align-items-center justify-content-end">
        <button
          type="button"
          data-bs-dismiss="offcanvas"
          className="btn btn-light me-2"
        >
          {t("cancel")}
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleSave} // for edit
          >
            {isEditMode ? "Update Lead" : "Create Lead"}
              </button>
              </div>
            </form>
          </div>
        </Offcanvas>
          {/* /Edit Lead */}
        
        {/* Delete Lead */}
        
       <div className="modal fade" id="delete_lead" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="text-center">
                <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                  <i className="ti ti-trash-x fs-36 text-danger" />
                </div>
                <h4 className="mb-2">{t("removeLead")}</h4>
                {/* <p className="mb-0">
                  Are you sure you want to remove <br /> the lead you selected.
                </p> */}
                <p className="mb-0">
                 {t("confirmRemove")} <br /> {t("selectedLead")}
                </p>
                <div className="d-flex align-items-center justify-content-center mt-4">
                  <Link to="#" className="btn btn-light me-2" data-bs-dismiss="modal">
                    {t("cancel")}
                  </Link>
                  <Link to="#" data-bs-dismiss="modal" className="btn btn-danger"  onClick={handleDeleteLead}>
                   {t("yesDeleteIt")}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    {/* /Delete Lead */}
        

        {/* Create Lead */}
        
        <Modal show={openModal2} onHide={() => setOpenModal2(false)}>
          <div className="modal-header border-0 m-0 justify-content-end">
            <button
              className="btn-close"
              onClick={() => setOpenModal2(false)}
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <div className="modal-body">
            <div className="success-message text-center">
              <div className="success-popup-icon bg-light-blue">
                <i className="ti ti-building" />
              </div>
              {/* <h3>Lead Created Successfully!!!</h3> */}
              <h3>{t("leadCreatedSuccess")}</h3>
              {/* <p>View the details of lead, created</p> */}
              <p>{t("viewLeadDetails")}</p>
              <div className="col-lg-12 text-center modal-btn">
                <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                  {t("cancel")}
                </Link>
                <Link to={route.leadsDetails} onClick={() => setOpenModal2(false)} className="btn btn-primary">
                 {t("viewDetails")}
                </Link>
              </div>
            </div>
          </div>
        </Modal>
        {/* /Create Lead */}
       

        {/* Create Company */}
        {/* <Modal show={openModal} onHide={() => setOpenModal(false)}>
          <div className="modal-header border-0 m-0 justify-content-end">
            <button
              className="btn-close"
              onClick={() => setOpenModal(false)}
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <div className="modal-body">
            <div className="success-message text-center">
              <div className="success-popup-icon bg-light-blue">
                <i className="ti ti-building" />
              </div>
              <h3>Company Created Successfully!!!</h3>
              <h3>{t("companyCreatedSuccess")}</h3>
              <p>View the details of company, created</p>
              <p>{t("viewCompanyDetails")}</p>
              <div className="col-lg-12 text-center modal-btn">
                <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                  {t("cancel")}
                </Link>
                <Link to={route.companyDetails} onClick={() => setOpenModal(false)} className="btn btn-primary">
                 {t("viewDetailsGeneric")}
                </Link>
              </div>
            </div>
          </div>
        </Modal> */}
        {/* /Create Company */}

        
        {/* Add New View */}
        <div className="modal custom-modal fade" id="save_view" role="dialog">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add New View</h5>
                <button
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="mb-3">
                    <label className="col-form-label">View Name</label>
                    <input type="text" className="form-control" />
                  </div>
                  <div className="modal-btn text-end">
                    <Link
                      to="#"
                      className="btn btn-light"
                      data-bs-dismiss="modal"
                    >
                      {t("cancel")}
                    </Link>
                    <button
                      type="button"
                      data-bs-dismiss="modal"
                      className="btn btn-danger"
                    >
                      Save
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* /Add New View */}
         
        {/* Access */}
        <div className="modal custom-modal fade" id="access_view" role="dialog">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Access For</h5>
                <button
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="mb-2 icon-form">
                    <span className="form-icon">
                      <i className="ti ti-search" />
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search"
                    />
                  </div>
                  <div className="access-wrap">
                    <ul>
                      {/* Dynamic list of people will be rendered here from API */}
                    </ul>
                  </div>
                  <div className="modal-btn text-end">
                    <Link
                      to="#"
                      className="btn btn-light"
                      data-bs-dismiss="modal"
                    >
                      {t("cancel")}
                    </Link>
                    <button
                      type="button"
                      data-bs-dismiss="modal"
                      className="btn btn-primary"
                    >
                      Confirm
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
       {/* /Access */}
      </>
    </>
  );
};

export default Leads;
function setForm(arg0: any) {
  throw new Error("Function not implemented.");
}

function createLeads(leads: { compy_name: string; phn1: string; phn2: string; email: string; website: string; source: string; industry: string; currency: string; language: string; description: string; leads_status: string; leads_name: string; created_date: string; }, voiceBlob: Blob | null) {
  throw new Error("Function not implemented.");
}

function setShowModal(arg0: boolean) {
  throw new Error("Function not implemented.");
}

